import timezonePickerStore from "../store/store";
import { mutatorAction } from "satcheljs";

export default mutatorAction('SET_TIMEZONE_OLSON_CODE', function setTimezoneOlsonCode(timezoneOlsonCode: string) {
    timezonePickerStore.timezoneOlsonCode = timezoneOlsonCode;
});
